import { firebaseDestinatariosRepository } from '../../infrastructure/destinatarios/firebaseDestinatario.repository'

export const addDestinatario = async destinatario => {
  const tag = await firebaseDestinatariosRepository.obtenerDestinatario(destinatario)
  if (!tag.exists) {
    firebaseDestinatariosRepository.guardarNuevoDestinatario(destinatario)
  }
}
